import { z } from 'zod';

export const lessonKindSchema = z.enum(['practice', 'diagnostic', 'progressMonitor']);
export type LessonKind = z.infer<typeof lessonKindSchema>;

export const LessonKindToLabel = {
  [lessonKindSchema.enum.practice]: 'Practice',
  [lessonKindSchema.enum.diagnostic]: 'Diagnostic',
  [lessonKindSchema.enum.progressMonitor]: 'Progress Monitor',
};
